import { JSEncrypt } from 'jsencrypt';
import MD5 from 'crypto-js/md5';
const publicKey = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwL4aIEULJOYYGnGNMvORWZR978yUAysIITt1IfCSAeGf2tJVuKhTf8qgxZGJICH1BBd6mJZxOPSSlitznlrEZJmDwHn+ktaCtCVcU6KrOO/ZJOnkmCe3seUVTorynTHQMNfvueL4/YGqTULwt6DMs3XtVoDAXst9RR/6b4JINcYAdAvjaNXRepxYL7P+8H8jQ0OTom2nvDGGIhX6ylasq33nYXmCxmF4uajRbQ5JfE3WKlNgEAPpFST8FbcoZWjJWw5L8Pg8jwvRsbUHWpH6TYGSpAeADuvcrGmRqn99/pEXJFpEeDQQed7OwvFh5UDAL9dxNPtlYeY07WJRMCWvOQIDAQAB-----END PUBLIC KEY-----';

/**
 * 返回 RSA加密后字符串
 * @param data
 */
export function secret(data, salt) {
  const encrypt = new JSEncrypt();
  if (!salt) {
    salt = '';
  }
  encrypt.setPublicKey(publicKey + salt);
  return encrypt.encrypt(data); //password为需要加密的字段
}

/**
 * 返回32位小写md5字符串
 * @param data
 */
export function md5(data, salt) {
  if (!salt) {
    salt = '';
  }
  return MD5(data + salt).toString();
}